import {Injectable} from '@angular/core';
import {ConfigService} from '../../config/config.service';
import {HttpClient} from '@angular/common/http';
import {DomainUrlService} from '../../config/domain-url.service';
import {UserContext} from '../../app-context/user-context/user-context';
import * as amplitude from 'amplitude-js';
import {AnalyticsDto} from '../analytics-dto';
import {defineProperty} from '../analytics.util';
import {LocalStorageKeyEnum} from '../../app-context/local-storage-key.enum';
import {Observable} from 'rxjs';
import {AnalyticsCategory} from '../analytics-category';
import {AnalyticsEventType} from '../analytics-event-type';

@Injectable({
              providedIn: 'root'
            })
export class AmplitudeService {

  private readonly DASHBOARD_TITLE = 'Dashboard';
  private readonly DASHBOARD_SEPARATOR = '_';
  analyticsDto: AnalyticsDto | undefined;

  constructor(private configService: ConfigService,
              private httpClient: HttpClient,
              private domainUrlService: DomainUrlService) {
  }

  public init(userContext: UserContext): void {
    if (!this.configService?.config?.amplitudeEnabled) {
      return;
    }

    if ('undefined' === typeof userContext) {
      return;
    }

    this.analyticsDtoObservable(userContext).subscribe(
      (result) => {
        this.initAnalyticsDto(result);
      }, error => {
        console.error(error);
      }
    );
  }

  private initAnalyticsDto(analyticsDto: AnalyticsDto): void {
    amplitude.getInstance().init(this.configService?.config?.amplitudeApiKey as string,
                                 analyticsDto.analyticsUserDto.referentielId,
                                 {includeReferrer: true});
    amplitude.getInstance().setSessionId(Number(analyticsDto.analyticsUserDto.sessionId));

    const userProperties = {
      profil: analyticsDto.analyticsUserDto.profil,
      solution: analyticsDto.solutions,
      product_offer: analyticsDto.analyticsAccountDto.segment,
      account_name: analyticsDto.analyticsAccountDto.name,
      account_id: analyticsDto.analyticsAccountDto.id,
      account_strate: analyticsDto.analyticsAccountDto.strateAccount
    };
    amplitude.getInstance().setUserProperties(userProperties);
    sessionStorage.setItem(LocalStorageKeyEnum.ANALYTICS, JSON.stringify(analyticsDto));
  }

  private analyticsDtoObservable(userContext: UserContext): Observable<AnalyticsDto> {
    return this.httpClient.get<AnalyticsDto>(`${this.domainUrlService.getOptimPortalBackApiUrl()}/rest/public/v1/account/analytics/${userContext.accountId}`) as Observable<AnalyticsDto>;
  }

  public trackEventProperties(eventP: string, eventPropertiesP?: Map<string, string>): void {
    const eventProperties = this.loadEventProperties();
    if ('undefined' === typeof eventProperties || 'undefined' === typeof eventProperties.account_id) {
      return;
    }
    eventPropertiesP.forEach((valueV, keyV) => defineProperty(eventProperties, keyV, valueV));

    amplitude.getInstance().logEvent(this.DASHBOARD_TITLE + this.DASHBOARD_SEPARATOR + eventP, eventProperties);
  }

  public trackEventAction(categoryP: AnalyticsCategory, eventP: AnalyticsEventType, eventPropertiesP: Map<string, string>): void {
    this.trackEventProperties(categoryP + this.DASHBOARD_SEPARATOR + eventP, eventPropertiesP);
  }

  private loadEventProperties(): any {
    this.analyticsDto = JSON.parse(sessionStorage.getItem(LocalStorageKeyEnum.ANALYTICS) as string);
    if (!this.analyticsDto) {
      return;
    }

    // eslint-disable-next-line consistent-return
    return {
      profil: this.analyticsDto.analyticsUserDto.profil,
      solution: this.analyticsDto.solutions,
      product_offer: this.analyticsDto.analyticsAccountDto.segment,
      account_name: this.analyticsDto.analyticsAccountDto.name,
      account_id: this.analyticsDto.analyticsAccountDto.id,
      account_strate: this.analyticsDto.analyticsAccountDto.strateAccount
    };
  }
}
